(function () {
  var ENDPOINT = 'https://graphql.loyoly.io/graphql/customer';
  var CACHE_KEY = 'loyoly:jwt';

  var cfg = window.LOYOLY || {};
  if (!cfg.apiKey) return;

  if (!cfg.externalId) return;

  function gql(query, variables, token) {
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = 'Bearer ' + token;
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ query: query, variables: variables || {} })
    })
      .then(function (r) { return r.json(); })
      .then(function (payload) {
        if (payload.errors && payload.errors.length) {
          throw new Error(payload.errors[0].message);
        }
        return payload.data;
      });
  }

  function token() {
    try {
      var hit = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (hit && hit.id === cfg.externalId && hit.exp > Date.now()) {
        return Promise.resolve(hit.token);
      }
    } catch (e) { }

    return gql(
      'mutation CustomerJwt($apiKey: String!, $externalId: String) {' +
      '  CustomerJwt(apiKey: $apiKey, externalId: $externalId) { token }' +
      '}',
      { apiKey: cfg.apiKey, externalId: cfg.externalId ? String(cfg.externalId) : null }
    ).then(function (data) {
      var t = data && data.CustomerJwt && data.CustomerJwt.token;
      if (!t) throw new Error('Loyoly: aucun jeton renvoye');
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({
          token: t, id: cfg.externalId, exp: Date.now() + 23 * 3600 * 1000
        }));
      } catch (e) { }
      return t;
    });
  }

  var QUERY_CUSTOMER =
    'query Customer { Customer {' +
    ' pointBalance vipPoints vipMultiplier referralCode levelId' +
    ' Level { id name pointsObjective multiplier iconUrl }' +
    '} }';

  var QUERY_LEVELS =
    'query VipLevels($locale: String) { VipLevels(locale: $locale) {' +
    ' id name pointsObjective multiplier iconUrl rewardPoints cashbackRate' +
    '} }';

  var QUERY_REWARDS =
    'query Rewards($locale: String) { Rewards(locale: $locale) {' +
    ' id name threshold promoType isSoldout' +
    '} }';

  function paint(name, value) {
    if (value === null || value === undefined || value === '') return;
    var nodes = document.querySelectorAll('[data-loyoly="' + name + '"]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = value;
  }

  function render(state) {
    var c = state.customer || {};
    var levels = (state.levels || []).slice().sort(function (a, b) {
      return (a.pointsObjective || 0) - (b.pointsObjective || 0);
    });

    paint('points', c.pointBalance);
    paint('multiplier', c.vipMultiplier);
    paint('referral', c.referralCode);
    paint('tier', c.Level && c.Level.name);

    var solde = c.pointBalance || 0;
    var atteignables = (state.rewards || []).filter(function (r) {
      return !r.isSoldout && (r.threshold || 0) <= solde;
    });
    paint('rewards-count', atteignables.length);

    var acquis = c.vipPoints || 0;
    var next = null;
    for (var i = 0; i < levels.length; i++) {
      if ((levels[i].pointsObjective || 0) > acquis) { next = levels[i]; break; }
    }
    if (next) {
      paint('next-tier', next.name);
      paint('next-tier-points', next.pointsObjective);
      paint('points-to-next', (next.pointsObjective || 0) - acquis);
    }

    document.documentElement.setAttribute('data-loyoly-ready', '');
    document.dispatchEvent(new CustomEvent('loyoly:ready', { detail: state }));
  }

  window.Loyoly = {
    token: token,
    query: function (q, v) { return token().then(function (t) { return gql(q, v, t); }); }
  };

  var locale = cfg.locale || null;
  token()
    .then(function (t) {
      return Promise.all([
        gql(QUERY_CUSTOMER, {}, t),
        gql(QUERY_LEVELS, { locale: locale }, t),
        gql(QUERY_REWARDS, { locale: locale }, t)
      ]);
    })
    .then(function (res) {
      render({
        customer: res[0] && res[0].Customer,
        levels: (res[1] && res[1].VipLevels) || [],
        rewards: (res[2] && res[2].Rewards) || []
      });
    })
    .catch(function (err) {
      document.documentElement.setAttribute('data-loyoly-error', '');
      if (window.console) console.warn('[Loyoly]', err.message);
    });
})();
